import gql from "graphql-tag";

const SubmitShippingRequest = gql`
  mutation(
    $reference_number: String!
    $temporary_id: String!
    $shipper_and_consignee_details: ShipperConsigneeDetailsInput
    $dangerous_goods: [DangerousGoodInput]
    $container_details: ContainerDetailsInput
    $certificate_documents: [SubmitRequestCertificateDocumentInput]
    $shipper_declaration: ShipperDeclarationInput
  ) {
    CreateShippingRequest(
      reference_number: $reference_number
      temporary_id: $temporary_id
      shipper_and_consignee_details: $shipper_and_consignee_details
      dangerous_goods: $dangerous_goods
      container_details: $container_details
      certificate_documents: $certificate_documents
      shipper_declaration: $shipper_declaration
    ) {
      id
    }
  }
`;

export default SubmitShippingRequest;
